import { useContext } from "react";
import { HomePageContext, PageNewState } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(HomePageContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
